import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "secondary-text-color text-body-2 mb-2" }
const _hoisted_3 = { class: "secondary-text-color text-body-2" }
const _hoisted_4 = { class: "text-body-1" }
const _hoisted_5 = { class: "secondary-text-color text-body-2" }
const _hoisted_6 = { class: "text-body-1" }
const _hoisted_7 = { class: "secondary-text-color text-body-2" }
const _hoisted_8 = { class: "text-body-1" }
const _hoisted_9 = { class: "secondary-text-color text-body-2" }
const _hoisted_10 = { class: "text-body-1" }
const _hoisted_11 = { class: "secondary-text-color text-body-2" }
const _hoisted_12 = { class: "secondary-text-color" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { reduce } from 'lodash'
import { isMobile } from '@/app/composables/useBreakpoints'
import { useGuestsCount } from '@/app/composables/useGuestsCount'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderInfoLine',
  setup(__props) {

const store = useStore()
const { t } = useI18n()
const { guestsCountString } = useGuestsCount()

const currentRoomStay = computed<{
  startDate: string
  endDate: string
  nbAdults: number
  nbChildren: number
  nbInfants: number
  room: {
    roomTypeName: string
  }
}>(() => store.getters.currentRoomStay)

const formatDate = computed(() => store.getters.formatDate)
const bookingRequest = computed(() => store.getters.bookingRequest)
const isAllRoomStaysBooked = computed<boolean>(
  () => store.getters.isAllRoomStaysBooked
)
const isMultiBooking = computed(
  () => bookingRequest.value.nbBookedRooms > 1 && isAllRoomStaysBooked.value
)

const nbGuests = computed(() => {
  const { nbAdults, nbChildren, nbInfants } = currentRoomStay.value
  return guestsCountString(nbAdults, nbChildren, nbInfants)
})

const roomStayOrders = computed<
  {
    nbAdults: number
    nbChildren: number
    nbInfants: number
  }[]
>(() => store.getters.roomStayOrders)

const nbGuestsTotal = computed(() => {
  const nbGuestsArray = reduce(
    roomStayOrders.value,
    (
      [nbAdultsTotal, nbChildrenTotal, nbInfantsTotal],
      { nbAdults, nbChildren, nbInfants }
    ) => [
      nbAdults + nbAdultsTotal,
      nbChildren + nbChildrenTotal,
      nbInfants + nbInfantsTotal
    ],
    [0, 0, 0]
  )

  return guestsCountString(...nbGuestsArray)
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('Checkout#ViewOrder#Title Your order:')), 1),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'text-caption': _unref(isMobile) }, 'mb-4'])
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Checkout#ViewOrder#Check-in Check-in:')), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(formatDate.value(currentRoomStay.value.startDate)), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ 'text-caption': _unref(isMobile) })
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('Checkout#ViewOrder#Guests Guests:')), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(nbGuests.value), 1)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'text-caption': _unref(isMobile) }, 'mb-4'])
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('Checkout#ViewOrder#Check-out Check-out:')), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(formatDate.value(currentRoomStay.value.endDate)), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ 'text-caption': _unref(isMobile) })
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('Checkout#ViewOrder#Room Room:')), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(currentRoomStay.value.room?.roomTypeName), 1)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (isMultiBooking.value)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          dense: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'text-caption': _unref(isMobile) })
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('Checkout#ViewOrder#Rooms Number of rooms:')), 1),
                  _createElementVNode("div", null, _toDisplayString(bookingRequest.value.nbBookedRooms), 1)
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'text-caption': _unref(isMobile) })
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('Checkout#ViewOrder#Guests Total guests:')), 1),
                  _createElementVNode("div", null, _toDisplayString(nbGuestsTotal.value), 1)
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})